export const INTEGRATION_NOTE_TYPE = 'INTEGRATION';
export const RELEASE_ISSUE_TAG_TEXT = 'Release Issue';
